<script>
    import Icon from '../icons/Icon.svelte';

    export let selectedNiche = {};
    export let groups = [];
    export let onReview = () => {};
    export let onChangeNiche = () => {};

    // Métricas inteligentes da base gerada
    $: totalGroups = groups.length;
    $: totalOptions = groups.reduce((acc, g) => acc + (g.items ? g.items.length : 0), 0);
</script>

<div class="smart-setup-flow">
    <!-- CABEÇALHO DA ETAPA 2 -->
    <div class="step-header-text">
        <span class="step-badge">Etapa 2 de 4 · Automação Inteligente</span>
        <div class="niche-title-row">
            <div class="niche-icon-pill">
                <Icon name={selectedNiche.svgIcon || 'utensils'} size={20} color="#FF6A00" />
            </div>
            <h2 class="step-title">{selectedNiche.name || 'Segmento Selecionado'}</h2>
            <button type="button" class="btn-change-niche" on:click={onChangeNiche}>
                Alterar
            </button>
        </div>
        <p class="step-subtitle">Preparamos uma base de complementos pronta para você começar a vender imediatamente.</p>
    </div>

    <!-- CARDS DE DESTAQUE / MÉTRICAS -->
    <div class="metrics-grid">
        <div class="metric-card">
            <span class="metric-number">{totalGroups}</span>
            <span class="metric-label">Grupos estruturados</span>
        </div>
        <div class="metric-card">
            <span class="metric-number">{totalOptions}</span>
            <span class="metric-label">Opções sugeridas com preços</span>
        </div>
    </div>

    <!-- PREVIEW RESUMIDO DOS GRUPOS GERADOS -->
    <div class="preview-section">
        <div class="section-heading">
            <span class="section-title">O que preparamos para o seu cardápio</span>
        </div>

        <div class="preview-groups-grid">
            {#each groups as group}
                <div class="preview-group-card">
                    <div class="group-info-top">
                        <span class="group-name">{group.name}</span>
                        <span class="group-badge {group.required ? 'is-required' : ''}">
                            {group.required ? 'Obrigatório' : 'Opcional'}
                        </span>
                    </div>
                    <div class="group-items-preview">
                        <span class="count-tag">{group.items ? group.items.length : 0} opções:</span>
                        <span class="items-text">
                            {group.items ? group.items.map(it => it.name).slice(0, 4).join(', ') : ''}
                            {#if group.items && group.items.length > 4}
                                e mais {group.items.length - 4}...
                            {/if}
                        </span>
                    </div>
                </div>
            {/each}
        </div>
    </div>

    <!-- MENSAGEM DE TRANQUILIDADE -->
    <div class="peace-of-mind-box">
        <div class="peace-icon">
            <Icon name="check" size={18} color="#059669" />
        </div>
        <p class="peace-text">
            Você terá controle total: poderá ativar, desativar, alterar preços e regras antes de salvar.
        </p>
    </div>

    <!-- AÇÃO PRINCIPAL -->
    <div class="step-footer-action">
        <button
            type="button"
            class="btn-review"
            on:click={onReview}
        >
            <span>Revisar configurações</span>
            <Icon name="arrow-right" size={16} color="#FFFFFF" />
        </button>
    </div>
</div>

<style>
    .smart-setup-flow {
        display: flex;
        flex-direction: column;
        gap: 22px;
        max-width: 820px;
        margin: 0 auto;
        width: 100%;
    }

    .step-header-text {
        text-align: left;
    }

    .step-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        color: #EA580C;
        background: #FFF7ED;
        padding: 3px 10px;
        border-radius: 6px;
        margin-bottom: 10px;
    }

    .niche-title-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 6px;
    }

    .niche-icon-pill {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        background: #FFF7ED;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .step-title {
        font-size: 24px;
        font-weight: 800;
        color: #0F172A;
        letter-spacing: -0.4px;
        margin: 0;
    }

    .btn-change-niche {
        background: none;
        border: none;
        color: #64748B;
        font-size: 12px;
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
        padding: 4px 8px;
        margin-left: 6px;
    }

    .btn-change-niche:hover {
        color: #0F172A;
    }

    .step-subtitle {
        font-size: 14px;
        color: #64748B;
        margin: 0;
        line-height: 1.5;
    }

    /* MÉTRICAS */
    .metrics-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .metric-card {
        padding: 16px 20px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .metric-number {
        font-size: 28px;
        font-weight: 800;
        color: #0F172A;
        line-height: 1;
    }

    .metric-label {
        font-size: 13px;
        color: #64748B;
        font-weight: 500;
    }

    /* PREVIEW SECTION */
    .preview-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .section-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .section-title {
        font-size: 13px;
        font-weight: 700;
        color: #334155;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .preview-groups-grid {
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 320px;
        overflow-y: auto;
        padding-right: 6px;
        padding-bottom: 4px;
        scrollbar-width: thin;
        scrollbar-color: #CBD5E1 transparent;
    }

    .preview-groups-grid::-webkit-scrollbar {
        width: 6px;
    }

    .preview-groups-grid::-webkit-scrollbar-track {
        background: #F1F5F9;
        border-radius: 6px;
    }

    .preview-groups-grid::-webkit-scrollbar-thumb {
        background: #CBD5E1;
        border-radius: 6px;
    }

    .preview-groups-grid::-webkit-scrollbar-thumb:hover {
        background: #94A3B8;
    }

    .preview-group-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 14px 18px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
    }

    .group-info-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .group-name {
        font-size: 14px;
        font-weight: 700;
        color: #0F172A;
    }

    .group-badge {
        font-size: 11px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 6px;
        background: #F1F5F9;
        color: #475569;
    }

    .group-badge.is-required {
        background: #FEF2F2;
        color: #B91C1C;
    }

    .group-items-preview {
        display: flex;
        align-items: baseline;
        gap: 6px;
        font-size: 13px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .count-tag {
        font-weight: 600;
        color: #64748B;
        flex-shrink: 0;
    }

    .items-text {
        color: #94A3B8;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* PEACE OF MIND */
    .peace-of-mind-box {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 18px;
        background: #F0FDF4;
        border: 1px solid #DCFCE7;
        border-radius: 10px;
    }

    .peace-icon {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #DCFCE7;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .peace-text {
        font-size: 13px;
        color: #166534;
        margin: 0;
        line-height: 1.4;
        font-weight: 500;
    }

    /* FOOTER */
    .step-footer-action {
        display: flex;
        justify-content: flex-end;
        padding-top: 14px;
        padding-bottom: 4px;
        border-top: 1px solid #E2E8F0;
        position: sticky;
        bottom: 0;
        background: #F8FAFC;
        z-index: 10;
    }

    .btn-review {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 46px;
        padding: 0 24px;
        background: #FF6A00;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 700;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
    }

    .btn-review:hover {
        background: #EA580C;
        box-shadow: 0 4px 12px rgba(255, 106, 0, 0.35);
        transform: translateY(-1px);
    }

    @media (max-width: 640px) {
        .metrics-grid {
            grid-template-columns: 1fr;
        }

        .btn-review {
            width: 100%;
            justify-content: center;
        }
    }
</style>
